module.exports = __webpack_public_path__ + "static/media/15.a8885dd9.png";